// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--SyNXo";
export var footerContent = "Footer-module--footer-content--sV5QX";
export var highlight = "Footer-module--highlight--0YQT-";
export var highlighted = "Footer-module--highlighted--nr9Xz";
export var item = "Footer-module--item--UfD6W";
export var itemHeader = "Footer-module--item-header--A1lzm";
export var itemLink = "Footer-module--item-link--qVL2t";
export var itemLinks = "Footer-module--item-links--NX0JK";
export var spacer = "Footer-module--spacer--kBWeh";